const baseUrlDefault = "http://tour.asiatech.ptp/";
export const SEARCH_RESULT_URL = `${process.env.NEXT_PUBLIC_BASE_URL_API}listing/search`;
export const SEARCH_RESULT_GROUP_URL = `${process.env.NEXT_PUBLIC_BASE_URL_API}group/tour-search`;

export const HOTEL_INFO_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_API_HOTEL || "http://api.b2c.asiatech.ptp/"
}hotel/api/v2/hotels/`;

export const HOTEL_REVIEW_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_API_HOTEL || "http://api.b2c.asiatech.ptp/"
}/hotel/review/v2/reviews/`;

export const HOTEL_RATES_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_API_HOTEL || "http://api.b2c.asiatech.ptp/"
}/hotel/review/v2/ratings/`;

export const CDN_IMAGE_AIRLINES_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_CDN_INT || "https://store.snapptrip.com"
}/assets/airlines/`;
export const CDN_IMAGE_TRAINS_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_CDN_INT || "https://store.snapptrip.com"
}/assets/train/`;

export const CREATE_DRAFT_API_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_API || baseUrlDefault
}booking/draft`;

export const TELESALES_API_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_TELESALE || "http://shared.asiatech.ptp/"
}telesales/requests`;

export const HOTEL_INTERNATIONAL_INFO_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_API || baseUrlDefault
}listing/int-hotels/`;

export const PASSENGERS_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_TICKET_API ||
  "http://api.ticket.asiatech.ptp/"
}passengers/v1/passengers`;

export const CITIES_QUERY_URL = `${
  process.env.NEXT_PUBLIC_TOUR_BASE_URL_API || baseUrlDefault
}static/cities`;

export const PRICE_CALENDAR_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_API || baseUrlDefault
}recommender/calendar`;

export const TOUR_REMINDER_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_API_HOTEL || "http://api.b2c.asiatech.ptp/"
}trip-notifier/v1/notify`;
